/** @format */

import axios from "./axios.js";
import Qs from "qs";
// import { Dialog } from 'vant';
import { ElMessage } from "element-plus";
import { test, formal } from "@/config/index";
import { ElMessageBox } from "element-plus";

var base_url = "http://119.45.235.140:3196";
// var powerbi = "//app.powerbi.cn/";
// var aie = "//192.168.0.111:8081/";
var file_load = "https://vdcurl.top";
// var file_path = "https://acc.ac.cn";

// var write_online = config_write || "http://43.137.16.233:1310";
// // var write_online = "https://cic.ln.cn"
// var wansi_url = "https://vcase.pub";
// var vcase_url = "http://49.232.135.204:8666";
// var rag = "https://appbuilder.baidu.com/s/";
// var qianfan = "https://qianfan.baidubce.com/";
// var deep = "http://192.168.1.111:11434";
var agent_url ="http://192.168.1.120:9000"

// 文件下载地址：接口返回的是相对路径（如 ClassStudent/xxx.zip），需拼上该域名才能下载
// 与 file_load（接口域名）分开配置，避免改动下载域名影响上传/导出接口
var file_down = "http://43.137.16.233:3196";

// 上传作品服务地址
var upload_url = "http://192.168.1.108:5000"

// 图片服务器
var img_url = "https://vdcfile.top"

if (test) { 
    console.log("开发环境");

    agent_url = "http://192.168.1.120:9000"; //杨旭
    // agent_url = "http://175.27.166.153:4988"; //线上测试服务器
    upload_url = "http://49.232.221.150:9100"; //线上上传服务器
    // file_load = "http://192.168.1.120:9000"; //杨旭
    file_down = "http://43.137.16.233:3196"; //文件下载地址
} else {
    // console.log("生产环境");
    agent_url = config_url || "http://175.27.166.153:4988";
    upload_url = config_upload_url || "http://49.232.221.150:9100";
    file_load = "https://vdcurl.top";
    // 线上可在 dist/static/js/config.js 里配 config_file_down，改完刷新即可，无需重新打包
    file_down = config_file_down || "http://43.137.16.233:3196";
}

var url = {
    // deepTest: deep,
    // //  + "/api/chat",

    // htmltest: base_url + "/Api/V1/Base_Test/UpdateTest",
    // upTest: qianfan + "v2/app/conversation/file/upload",
    // LoginVdc: base_url + "/Api/V1/Login/LoginVdc",

    // 基础功能
    echarts: "/static/echarts/index.html?x=" + Math.random(),
    reg: agent_url + "/Api/V1/Table_User/AddUserInfo/", //注册
    login: agent_url + "/Api/V1/Login/Login/", //登录 //LoginRefClassCount Login
    Select_Schools: agent_url + "/Api/V1/Common/GetSchoolList/", //学校数据
    reuser: agent_url + "/Api/V1/Table_User/UpdateUserInfo/", //修改个人信息
    repwd: agent_url + "/Api/V1/Table_User/UpdateUserPwd/", //修改密码
    // GetPbiMenuList: base_url + "/Api/V1/M_PbiMenu/GetPbiMenuList", //
    CheckUserTel: agent_url + "/Api/V1/Login/CheckUserTel", //
    // 忘记密码
    CheckUser: agent_url + "/Api/V1/Common/CheckUser", //第一步
    SendEmail: agent_url + "/Api/V1/Common/SendEmail", //发送邮件
    UpdatePwdByEmail: agent_url + "/Api/V1/Table_User/UpdatePwdByEmail", //第二步
    SendSms: agent_url + "/Api/V1/Log_SMS/SendSms",
    // 会员中心
    // GetUserM_LicenseDays:
    //     base_url + "/Api/V1/D_UserLicenseType/GetUserM_LicenseDays",
    // GetLicenseTypeList: base_url + "/Api/V1/M_LicenseType/GetLicenseTypeList",
    // AddUserPayData: base_url + "/Api/V1/D_UserPayData/AddUserPayData",
    // GetUserPayResult: base_url + "/Api/V1/D_UserPayData/GetUserPayResult",
    // ActivationUserLicense:
    //     base_url + "/Api/V1/D_VDCUsageStatistics/ActivationUserLicense",

    // VcaseLogin: base_url + "/Api/V1/Table_User/VcaseLogin", //
    HomeTotalData: agent_url + "/Api/V1/Common/HomeTotalData", //数据统计
    HomeTotalDataWeek: agent_url + "/Api/V1/Common/HomeTotalDataWeek", //周数据统计


    // 智能体
    GetPagesClassMaster: agent_url + "/Api/V1/M_ClassMaster/GetPagesClassMaster", //获取标准课程列表
    GetPagesClassDetail: agent_url + "/Api/V1/M_ClassDetail/GetPagesClassDetail", //获取标准课程下的标准任务列表

    GetPagesTaskDetail: agent_url + "/Api/V1/M_TaskDetail/GetPagesTaskDetail", //获取全部任务列表
    GetTaskDetailList: agent_url + "/Api/V1/M_TaskDetail/GetTaskDetailList", //按条件获取任务列表（课程属性+任务类别）
    GetTaskTypeList: agent_url + "/Api/V1/M_TaskType/GetTaskTypeList", //获取任务类型
    GetClassTaskList: agent_url + "/Api/V1/M_ClassTask/GetClassTaskList", //获取任务得属性
    GetDifficultyList: agent_url + "/Api/V1/M_Difficulty/GetDifficultyList", //获取难易程度

    AddFaiClassData: agent_url + "/Api/V1/D_FaiClassData/AddFaiClassData", //创建课程
    GetFaiClassDataByUser: agent_url + "/Api/V1/D_FaiClassData/GetFaiClassDataByUser", //通过用户获得我的课程列表
    GetFaiClassTaskDataByClass: agent_url + "/Api/V1/D_FaiClassData/GetFaiClassTaskDataByClass", //获取课程下任务

    GetStudentPagesFaiClassData: agent_url + "/Api/V1/D_FaiClassData/GetStudentPagesFaiClassData", //学生端获取已加入课程列表 / 教师端获取课程下学生列表
    DeleteFaiClassData: agent_url + "/Api/V1/D_FaiClassData/DeleteFaiClassData", //删除课程
    UpdateFaiClassData: agent_url + "/Api/V1/D_FaiClassData/UpdateFaiClassData", //修改课程（名称/描述）
    PublishFaiClassTask: agent_url + "/Api/V1/D_FaiClassTaskData/UpdateFaiClassTaskDataList", //发布课程下任务
    DeleteFaiClassTaskData: agent_url + "/Api/V1/D_FaiClassTaskData/DeleteFaiClassTaskData", //取消发布课程下任务
    AddStudentList: agent_url + "/Api/V1/Table_StudentList/AddStudentList", //学生加入课程
    GetPagesStudentList: agent_url + "/Api/V1/Table_StudentList/GetPagesStudentList", //获取课程下学生列表
    DeleteStudentList: agent_url + "/Api/V1/Table_StudentList/DeleteStudentList", //删除学生（移出班级）
    GetPagesStudentScoreList: agent_url + "/Api/V1/D_StudentTaskScoreData/GetPagesStudentScoreList", //获取学生成绩列表
    GetUserPoint: agent_url + "/Api/V1/D_StudentTaskScoreData/GetUserPoint", //获取积分数（无参）
    UpdatePointStatus: agent_url + "/Api/V1/D_StudentTaskScoreData/UpdatePointStatus", //领取任务积分

    // 上传作品
    uploadIngest: upload_url + "/upload-api/ingest", //上传作品
    uploadProducts: upload_url + "/upload-api/products", //查询上传状态

    // 上传测试报告
    UploadTaskAttachmentFile: file_load + "/Api/V1/Table_TaskList/UploadTaskAttachmentFile/",
    AddFAIUpdateReportMyUpload: file_load + "/Api/V1/Table_TaskList/AddFAIUpdateReportMyUpload",
    GetClassStudentUploadFileFAI: file_load + "/Api/V1/Common/GetClassStudentUploadFileFAI", // 教师端导出测试文件

};
var obj = {
    img_url,
    // file_path,
    url,
    base_url,
    agent_url,
    upload_url,
    // vcase_url,
    // powerbi,
    // aie,
    // rag,
    file_load,
    file_down,
    // write_online,
    // wansi_url,
    // qianfan,
    // deep,
    scope: {},
    post(config) {
        var p_url = url[config.url] || config.url;
        config.data = config.data || {};

        /*
            ID: "114"
            account: "001"
            email: "yk@163.com"
            msg: "登录成功"
            name: "liu"
            school: "产品支持"
            telephone: "18640195989"
        */
        if (
            config.url != "login" &&
            this.store.Header &&
            this.store.Header.Guid
        ) {
            config.data.Header = this.store.Header;
        }
        axios
            .post(p_url, config.data)
            .then((res) => {
                // if (config.file) {
                //     console.log('postfile:',res.data)
                //     var blob = new Blob([res.data], {
                //         type: {
                //             xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                //         } [config.fileType]
                //     });
                //     window.open(window.URL.createObjectURL(blob))
                //     return
                // }
                // console.log(res)
                if (res.data || res.data.toString) {
                    // console.log("res.data:",config.url,res.data)
                    if (res.data.Status) {
                        switch (res.data.Status) {
                            case -3:
                            case "-3":
                            // 您还未登陆
                            case -7:
                            case "-7":
                                // 超时
                                localStorage.Header = "";
                                this.store.out_url =
                                    location.pathname + location.search;
                                ElMessageBox.alert(
                                    "尊敬的用户:我们检测到您的账号于 [" +
                                        res.data.OccurDateTime +
                                        "] 进行了登录操作。这可能是一个安全风险，建议您立即登录账号后到个人设置里面进行密码修改操作。为了您的账号安全，请务必保持警惕，并定期更新您的密码。",
                                    "账号重复登录警告！",
                                    {
                                        confirmButtonText: "确定",
                                        callback: (action) => {
                                            if (action === "confirm") {
                                                // console.log('用户点击了确定按钮');
                                                this.app.$router.replace({
                                                    name: "login",
                                                });
                                                // 这里可以添加关闭消息框的逻辑，但实际上 ElMessageBox.alert 的消息框在点击确认后会自动关闭
                                            } else {
                                                this.app.$router.replace({
                                                    name: "login",
                                                });
                                            }
                                        },
                                    }
                                );
                                break;
                            case -6:
                            case "-6":
                                // 权限不足
                                if (this.app.$route.matched.length > 1) {
                                    this.app.$router.back();
                                } else {
                                    this.app.$router.replace({ name: "login" });
                                }
                                break;
                        }
                        if (config.fail) {
                            config.fail(res.data);
                            return;
                        }
                        ElMessage({
                            message: "提示:" + res.data.message,
                            type: "error",
                        });
                        /*Notification.error({
                            title: '提示',
                            message: res.data.msg
                        })*/
                        return;
                    }
                    /*Notification.success({
                        title: '提示',
                        message: res.data.msg
                    })*/
                    config.success && config.success(res.data);
                    return;
                }
                ElMessage({
                    message: "接口返回为空",
                    grouping: true,
                    type: "error",
                });
            })
            .catch((error) => {
                console.log("error", [error]);
                var err_res = {
                    msg: "接口返回失败",
                };
                if (error.response) {
                    err_res.msg =
                        {
                            "Internal Server Error": "内部服务器错误",
                        }[error.response.statusText] ||
                        (error.response.data && error.response.data.Message) ||
                        "接口返回失败";
                } else {
                    err_res.msg = "页面程序错误";
                }
                if (config.fail) {
                    config.fail({
                        // errCode: 500,
                        msg: err_res.msg,
                    });
                } else {
                    ElMessage({
                        message: err_res.msg,
                        grouping: true,
                        type: "error",
                    });
                    if (!error.response) {
                        console.error(error.stack);
                    }
                }
                config.error &&
                    config.error({
                        url: p_url,
                    });
            });
    },
    get(config) {
        var p_url = url[config.url] || config.url;
        config.data = config.data || {};
        /*
            ID: "114"
            account: "001"
            email: "yk@163.com"
            msg: "登录成功"
            name: "liu"
            school: "产品支持"
            telephone: "18640195989"
        */
        /*if(this.store.user.ID){
            config.data.school = this.store.user.school
            config.data.account = this.store.user.account
            config.data.name = this.store.user.name
        }
        let params = new URLSearchParams();
        for (var i in config.data) {
            if (config.data[i] instanceof Array) {
                for (var j = 0; j < config.data[i].length; j++) {
                    params.append(i, config.data[i][j]);
                };
            } else if (config.data[i] instanceof Object) {
                params.append(i, JSON.stringify(config.data[i]));
            } else {
                params.append(i, config.data[i]);
            }
        };
        config.data = params;*/
        // console.log("get", p_url);
        axios
            .get(p_url, config.data, {
                maxContentLength: 4000,
            })
            .then(function (res) {
                if (res.data || res.data.toString) {
                    if (res.data.errCode || res.data.Status) {
                        if (config.fail) {
                            config.fail(res.data);
                            return;
                        }
                        ElMessage({
                            message: "提示:" + res.data.message,
                            type: "error",
                        });
                        /*Notification.error({
                            title: '提示',
                            message: res.data.msg
                        })*/
                        return;
                    }
                    /*Notification.success({
                        title: '提示',
                        message: res.data.msg
                    })*/
                    config.success && config.success(res.data);
                    return;
                }
                ElMessage({
                    message: "接口返回为空",
                    grouping: true,
                    type: "error",
                });
            })
            .catch(function (error) {
                if (config.fail) {
                    config.fail({
                        errCode: 500,
                        msg: "接口返回失败",
                    });
                } else {
                    ElMessage({
                        message: "接口返回失败",
                        grouping: true,
                        type: "error",
                    });
                }
                config.error &&
                    config.error({
                        url: p_url,
                    });
            });
    },
    url_obj() {
        return Qs.parse(location.search.replace("?", ""));
    },
    url_str(obj, _h = "") {
        return _h + Qs.stringify(obj);
    },
    get_url_argument(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURI(window.location.search).substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    get_url_argument_obj(str) {
        var obj = {};
        var reg = new RegExp("([^\\?|&]*)=([^&]*)", "g");
        var r = decodeURI(str || window.location.search).match(reg);
        if (r) {
            for (var i = 0; i < r.length; i++) {
                var t = r[i].split("=");
                obj[t[0]] = t[1];
            }
        }
        return obj;
    },
    url_passer(obj, key) {
        var _this_ = this;
        var returnStr = "";
        switch (typeof obj) {
            case "string":
            case "number":
            case "boolean":
                returnStr += "&" + key + "=" + obj;
                break;
            default:
                for (var i in obj) {
                    if (typeof obj[i] !== "function") {
                        if (key && key !== "?" && key !== "&") {
                            returnStr += _this_.url_passer(
                                obj[i],
                                key + "[" + i + "]"
                            );
                        } else {
                            returnStr += _this_.url_passer(obj[i], i);
                        }
                    }
                }
                break;
        }
        switch (key) {
            case "&":
                return returnStr.replace(/^./, "");
            case "?":
                return returnStr.replace(/^./, "?");
        }
        /*if (key === '?') {
            return returnStr.replace(/^./, '?')
        } else if (key === '&') {
            return returnStr.replace(/^./, '')
        }*/
        return returnStr;
    },
    column_prop_filter(item, first = [], not = []) {
        var arr = [];
        var keys = Object.keys(item);
        // console.log("column_prop_filter",keys,first,not)
        arr = first.filter((a_item) => {
            return keys.indexOf(a_item) != -1;
        });
        arr = arr.concat(
            keys.filter((a_item) => {
                return [...first, ...not].indexOf(a_item) == -1;
            })
        );
        return arr;
    },
    list_page_filter(list, page, page_size = 10) {
        var arr = [...list];
        arr = arr.slice((page - 1) * page_size, page * page_size);
        return arr;
    },
    arr_a_filter_b(a, b = []) {
        return a.filter((a_item) => {
            return b.indexOf(a_item) == -1;
        });
    },
    str_filter(val, _config, recursion) {
        _config = {
            s: 6,
            e: 4,
            ..._config,
        };
        if (!val) {
            return val;
        }
        return (
            val.substring(0, _config.s) +
            "..." +
            val.substring(val.length - _config.e)
        );
    },
    /*testFun(){
        console.log("testFun",this)
    }*/
    createDownLoad(content, fileName) {
        const link = document.createElement("a");
        link.href = content;
        const d = new Date();
        link.download =
            fileName ||
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
        link.target = "_blank";
        const ev = document.createEvent("MouseEvents");
        ev.initMouseEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
        );
        link.dispatchEvent(ev);
    },
};
// String.prototype._ajax = obj
// String.prototype._testFun = obj.testFun

export default obj;
